import React from "react";
// import Word from './Word';

import "./CompletedCategories.scss";

const CompletedCategories = ({
  completed,
  categoryThings,
  categoryColors,
  categoryTextColor,
}) => {
  const completedCategories = completed.map((category, index) => {
    let things = categoryThings[category].join(", ");
    if (category === "Newest destinations in our network")
      things = "Cancun (CUN), Riyadh (RUH), Seoul (ICN), Toronto (YYZ)";
    return (
      <div
        className="CompletedCategory"
        key={`category-${category}`}
        style={{
          backgroundColor: categoryColors[index],
          color: categoryTextColor || "white",
        }}
      >
        <div className="title">{category}</div>
        <div className="things">{things}</div>
        {category === "Found in flight" && (
          <span className="things">*Featured on our fleet of A330neo's</span>
        )}
      </div>
    );
  });

  return <div className="CompletedCategories">{completedCategories}</div>;
};

export default CompletedCategories;
